import Cookies from 'js-cookie';
import { EXPRESS_API } from 'configs/api/expressApi';
import SharedDrop from 'lib/context/SharedDrop';

const Droplr = require('droplr-api');

export let client: any;

export const checkDropAuth = async () => {
  if (!client) {
    const { data } = await EXPRESS_API.get('/droplr/auth');
    Cookies.set('jwtToken', data.jwt, {
      domain: '.covideo.com',
      sameSite: 'strict',
      secure: true,
    });
    client = new Droplr.Client({
      auth: new Droplr.JwtAuth(data.jwt),
    });

    client.sharedDrop = new SharedDrop(client);
  }
};
